export const ROOT_ACTION_TYPES = {

    PREFETCH_START: 'PREFETCH_START',
    PREFETCH_FINISHED: 'PREFETCH_FINISHED',
    
};